import { type InternalAxiosRequestConfig } from 'axios';

const getAccountUuid = () => {
  const accountUuid = sessionStorage.getItem('accountUuid');

  if (!accountUuid) {
    throw new Error('please provide an accountUuid');
  }

  return accountUuid;
};

const createAccountUrlInterceptor = (basePath: string) => (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const accountUuid = getAccountUuid();

  return {
    ...config,
    url: `${basePath}/${accountUuid}${config.url ?? ''}`,
  };
};

export const requestWebapiInterceptor = createAccountUrlInterceptor('/webapi/accounts');

export const requestWebapiSettingsInterceptor = createAccountUrlInterceptor('/webapi/settings/accounts');

export const requestApiInterceptor = createAccountUrlInterceptor('/accounts');
